export default __webpack_public_path__ + "static/media/info.a35bae73.svg";